// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__jfOHk","iconButton":"style_iconButton__QJJfR","icon":"style_icon__hOl8W","badge":"style_badge__tQBZy"};